module.exports = require("!!vue-loader!./../../node_modules/vue-markdown-loader/.cache/sample-1.vue");


//////////////////
// WEBPACK FOOTER
// ./docs/examples/sample.md
// module id = 23
// module chunks = 1